
























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '../../../lib/abpbase'
    class Edithandlereturn {
        id: number;
        returnNo: string="";
        returnExpressCompany: string="";
        expressCost: number;
        constructor() {
            this.returnExpressCompany = null;
        }

    }
    @Component
    export default class ReturnHandleModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        handlereturn: Edithandlereturn = new Edithandlereturn();
        submit() {
            this.save();
        }
        save() {
            (this.$refs.ReturnHandleForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'returnrejection/ConfirmDeduction',
                        data: this.handlereturn
                    });
                    (this.$refs.ReturnHandleForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        cancel() {
            (this.$refs.ReturnHandleForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                var data = this.$store.state.returnrejection.confirmReturnInfo;

                this.handlereturn.id = data.id;
            }
        }

    }
